<script lang="ts">
  import type { LinkInterface } from '$types/interfaces';
  import FooterLink from '$components/footer/FooterLink.svelte';

  export let title: string;
  export let links: LinkInterface[][];
</script>

<div class="footer-section">
  <h4>{title}</h4>
  <div class="footer-section__links">
    {#each links as column}
      <div class="footer-section__links__column">
        {#each column as link}
          <FooterLink {link} />
        {/each}
      </div>
    {/each}
  </div>
</div>

<style lang="scss">
  .footer-section {
    margin-top: 10px;
    h4 {
      width: 100%;
      margin-bottom: 23px;
      font-size: 20px;
      font-weight: 700;
    }
    &__links {
      display: flex;
      gap: 100px;
    }
  }
</style>
